module.exports = __webpack_public_path__ + "img/三大核心背景.33675310.png";